import React from 'react';
import styled from 'styled-components/native';

import { padding } from '@src/configuration/constants';
import { User } from '@src/types';

import AvatarBase from './Avatar';
import FontIcon from './FontIcon';
import Score from './Score';
import { Body1, H3 } from './Typography';

type Props = {
  user?: User;
  rate?: number;
  description?: string;
};

const Container = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0px ${padding / 2}px;
  margin: 5px auto;
`;

const Row = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Column = styled.View`
  flex-direction: column;
  align-items: stretch;
`;

const Avatar = styled(AvatarBase)`
  align-self: center;
  margin: 0px auto;
`;

const Username = styled(H3)`
  margin-bottom: ${padding / 3}px;
`;

const Description = styled(Body1)`
  flex-wrap: wrap;
  padding: 0px ${padding / 2}px;
`;

const Star = styled(FontIcon).attrs({
  name: 'star-o',
  size: 12,
})`
  align-self: center;
`;

const Component: React.FC<Props> = (props) => {
  const { user, rate, description } = props;
  const avatar = user?.avatar ?? require('@src/assets/images/avatar.png');

  return (
    <>
      <Container>
        <Column style={{ justifyContent: 'center', marginRight: 5 }}>
          <Avatar source={avatar} />
        </Column>
        <Column style={{ flexGrow: 1, marginHorizontal: 5 }}>
          <Username>{user?.name || user?.username || ''}</Username>
          <Score value={rate ?? 0}>
            <Star />
          </Score>
        </Column>
      </Container>
      <Row>
        <Description>{description}</Description>
      </Row>
    </>
  );
};

export default Component;
